export default "<plain-text [data]=\"data\"></plain-text>\n\n<card-thumbnail (clickEvent)=\"reloadChat($event)\" [data]=\"submits\"></card-thumbnail>";